import React from 'react';
import { styled } from '@compiled/react';
import Spinner from '@atlaskit/spinner';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { LoadingStateOptions } from '@atlassian/jira-software-deployments-service-query-types';
import { useCoreData } from '../../../../services/core-data';
import messages from './messages';

export const LoadingStatusIndicator = () => {
	const {
		serviceResult: { loadingState, data },
		getNextIssuePage,
		hasReachedMaxIssuesLimit,
	} = useCoreData();
	const { formatMessage } = useIntl();

	const issuesCount = data?.issues.length ?? 0;
	const isLoading = loadingState === LoadingStateOptions.LOADING_NEXT_PAGE;

	const message = hasReachedMaxIssuesLimit
		? formatMessage(messages.maxIssues)
		: formatMessage(messages.allIssues, { issuesCount });

	return (
		<ContentContainer>
			{isLoading && <Spinner size="small" />}
			{!isLoading && getNextIssuePage === null && <span>{message}</span>}
		</ContentContainer>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ContentContainer = styled.div({
	display: 'flex',
	justifyContent: 'center',
	padding: token('space.150', '12px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.subtlest', colors.N200),
	textAlign: 'center',
});
